<header class="pda-header-wrapper">
    <div class="pda-header" [ngClass]="{'showMenu': showMenu}">
        <figure class="pda-header-logo">
            <img src="assets/images/logo_allegra.png" alt="" class="pda-header-logo-img">
        </figure>
        <nav class="pda-header-nav">
            <ul class="pda-header-nav-list">
                <li class="pda-header-nav-item">
                    <a [routerLink]="['/']">INICIO</a>
                </li>
                <li class="pda-header-nav-item">
                    <a [routerLink]="['/nosotros']">NOSOTROS</a>
                </li>
                <li class="pda-header-nav-item">
                    <a [routerLink]="['/staff']">STAFF</a>
                </li>
                <li class="pda-header-nav-item">
                    <a [routerLink]="['/clases']">CURSOS</a>
                </li>
            </ul>
        </nav>
        <div class="pda-header-avatar">
            <div class="pda-header-avatar-login">
                <button *ngIf="!user; else activeUser"
                    class="pda-btn outline md"
                    [routerLink]="['/login']">Iniciar sesi&oacute;n</button>
                <ng-template #activeUser>
                    <pda-user-avatar></pda-user-avatar>
                </ng-template>
            </div>
            <div class="pda-header-avatar-menu" (click)="toggleMenu()">
                <span class="menu-btn">Menu</span>
            </div>
        </div>
        <div class="pda-header-close-menu">
            <span class="pda-header-close-menu-icon"(click)="showMenu=false;">
                <i class="bi bi-x-lg"></i>
            </span>
        </div>
    </div>
    <div class="pda-header mobile full-height" *ngIf="showMenu">
        <ul class="pda-header-nav-menu">
            <li class="pda-header-nav-item">
                <a [routerLink]="['/']">INICIO</a>
            </li>
            <li class="pda-header-nav-item">
                <a [routerLink]="['/nosotros']">NOSOTROS</a>
            </li>
            <li class="pda-header-nav-item">
                <a [routerLink]="['/staff']">STAFF</a>
            </li>
            <li class="pda-header-nav-item">
                <a [routerLink]="['/clases']">CURSOS</a>
            </li>
            <li class="pda-header-nav-item">
                <button *ngIf="!user" class="pda-btn primary md" [routerLink]="['/login']">Iniciar sesi&oacute;n</button>
            </li>
        </ul>
    </div>
</header>
